var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTopPlayers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 101.15 69.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:5.67px;}.cls-2{font-size:17.01px;fill:#f9f9fa;font-family:MyriadHebrew-Regular, Myriad Hebrew;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "top-players") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "2.83 21.16 31.48 21.16 31.48 2.83 68.57 2.83 68.57 30.45 98.32 30.45 98.32 67.09 2.83 67.09 2.83 21.16"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(42.25 25.54)"
  }, "1"), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(79.67 52.38)"
  }, "3"), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(12.32 49.54)"
  }, "2")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopPlayers);
export default __webpack_public_path__ + "static/media/top-players.5da20225f88cd91dc888771c07a1f354.svg";
export { ForwardRef as ReactComponent };